var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@/models/User';
import AlertCard from '@/components/alert-card/AlertCard';
import LoaderCard from '@/components/loader-card/LoaderCard';
import BookmarksDialog from '@/components/BookmarkWidget/BookmarksDialog/BookmarksDialog.vue';
import ErrorHandler from '@/support/ErrorHandler';
let BookmarkWidget = class BookmarkWidget extends Vue {
    constructor() {
        super(...arguments);
        this.isShowingCreateDialog = false;
        this.bookmarks = [];
        this.isLoading = true;
        this.selectedBookmark = null;
        this.confirmingDelete = false;
        // #endregion
        // Watchers
        // #endregion
    }
    mounted() {
        this.$root.$on('locale-changed', this.initialise);
        this.initialise();
    }
    async initialise() {
        this.isLoading = true;
        await this.fetchBookmarks();
        this.isLoading = false;
    }
    onOpenBookmarkDialog() {
        this.isShowingCreateDialog = true;
    }
    async onCloseDialog() {
        this.isShowingCreateDialog = false;
        this.confirmingDelete = false;
        this.selectedBookmark = null;
        await this.fetchBookmarks();
    }
    onEditBookmark(bookmark) {
        this.selectedBookmark = bookmark;
        this.isShowingCreateDialog = true;
    }
    onDeleteBookmark(bookmark) {
        this.selectedBookmark = bookmark;
        this.confirmingDelete = true;
        this.isShowingCreateDialog = true;
    }
    parseUrl(bookmarkLink) {
        return bookmarkLink;
    }
    // Asyncs
    async fetchBookmarks() {
        this.confirmingDelete = false;
        try {
            this.bookmarks = await this.$store.state.Auth.limit(500).listBookmarks();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof User !== "undefined" && User) === "function" ? _a : Object)
], BookmarkWidget.prototype, "user", void 0);
BookmarkWidget = __decorate([
    Component({
        components: {
            AlertCard,
            LoaderCard,
            BookmarksDialog,
        },
    })
], BookmarkWidget);
export default BookmarkWidget;
